export default {
  /* eslint-disable */
  png: { color: '#E1D9FD', hasThumbnail: true, hasPreview: true, type: 'image' },
  jpg: { color: '#FFB27B', hasThumbnail: true, hasPreview: true, type: 'image' },
  tif: { color: '#C1E0EB' },
  gif: { color: '#E8A1E5' },
  svg: { },
  webp: { color: '#E1D9FD', hasThumbnail: true, hasPreview: true, type: 'image' },

  txt: { color: '#9EF3F3' },
  csv: { color: '#9EF3F3' },
  html: { color: '#9EF3F3' },

  rar: { color: '#FFEAB5' },
  zip: { color: '#FFEAB5' },
  '7z': { color: '#FFEAB5' },

  pdf: { hasPreview: true, type: 'pdf' },
  rtf: { },
  psd:  { color: '#7FA3E9' },
  skp: {},

  odt:  { color: '#94CCFF' },
  ods:  { color: '#8CE2A4' },
  odp:  { },

  doc:  { color: '#94CCFF' },
  vsd:  { },
  xls:  { color: '#8CE2A4' },
  ppt:  { },

  pln: {},
  dwg: {},
  max: {},
  cdr: {},
  cpt: {},

  mp4: { hasPreview: true, type: 'video' },
  mov: {},
  wmv: {},
  avi: {},
  webm: {},
  flv: {},
  mkv: {},
  wav: {},
  aiff: {},
  mp3: {},
  aac: {},
  ogg: {},
  wma: {},
  flac: {},
  '3gp': {},
  '3g2': {},
  '3gpp': {},
};

